<template>
    <div>
        <compFormQuery v-if="alltype=='query'" class="margin-top-15"  :formdata="getCustomer" :value="formData" :labelWidth="180"></compFormQuery>
		<compFormEdit v-else class="margin-15 clearfix" ref="editform" :formdata="getCustomer" v-model="formData" :labelWidth="180" />
    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import { HttpAllCustomerAddressList } from "@/service/boss/b2border";
// 
export default {
	props:['cusdata','alltype'],
    components: {
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
	},
    data(){
        return {
			formData:{},
			shipaddressList:[],
			billaddressList:[],
			item1:{},
			item2:{},
			chooseCusId:null,
			olddata:{},
			cusflag:1,
			clickflag:1,
        }
	},
	watch:{
        cusdata:{
            deep:true,
            handler(val){
				if(this.cusflag == 1){
					let {customerId,shipTo,billTo} = val
					this.olddata = {customerId,shipTo,billTo}
					this.getAllAddress(customerId)
					this.cusflag = 2
				}
				
            }
        },
	},
    computed:{
        ...mapGetters('diction',['getAllCustomerList']),
        getCustomer(){
            return [
                {
					label: this.$t('erp.b2border.customerName',{defaultValue:'客户姓名'}),
					key: "customerId",
					tag: "vSelect",
                    span:24,
					options: this.getAllCustomerList,
					on:{
						'on-change':(value)=>{
							this.getCustomerlist(value)
							this.changeSales(value)
						}
					},
					props: {
						filterable: true,
					},
					formItem:{
						style:"width:50%",
						tip:this.alltype != 'query' ? "<span style='color: red'><a target='_blank' href=\""+process.env.VUE_APP_ERP + '/home/customerList'+"\">"+this.$t('erp.b2border.customer_tip',{defaultValue:'点击维护客户信息'})+"<a></span>" : '',
					}
                },
                {
					label: this.$t('erp.b2border.shipping_address',{defaultValue:'收货地址'}),
					key: "shipTo",
					tag: "vSelect",
                    // query: showquery,
					options: this.shipaddressList.map((item) => {
						return {
							value: item.id,
							label: item.address1
						}
					}),
					on:{
						'on-change':(val)=>{
							this.detailAddress(val,'ship',false)
						}
					},
					props: {
						filterable: true,
					}
                },
                {
					label: this.$t('erp.b2border.invoice_address',{defaultValue:'发票地址'}),
					key: "billTo",
					tag: "vSelect",
                    // query: showquery,
					options: this.billaddressList.map((item) => {
						return {
							value: item.id,
							label: item.address1
						}
					}),
					on:{
						'on-change':(val)=>{
							this.detailAddress(val,'bill',false)
						}
					},
					props: {
						filterable: true,
					}
                },
                // 1
                {
					label: this.$t('erp.b2border.linkman',{defaultValue:'联系人'}),
					key: "contact",
					required:false,
					props:{
						readonly:true
					}
                },
                {
					label: this.$t('erp.b2border.linkman',{defaultValue:'联系人'}),
					key: "billcontact",
					required:false,
					props:{
						readonly:true
					}
                },
                // 2
                {
					label: this.$t('erp.b2border.addressone',{defaultValue:'地址1'}),
					key: "address1",
					required:false,
					props:{
						readonly:true
					}
                },
                {
					label: this.$t('erp.b2border.addressone',{defaultValue:'地址1'}),
					key: "billaddress1",
					required:false,
					props:{
						readonly:true
					}
                },
                // 3
                {
					label: this.$t('erp.b2border.addresstwo',{defaultValue:'地址2'}),
					key: "address2",
					required:false,
					props:{
						readonly:true
					}
                },
                {
					label: this.$t('erp.b2border.addresstwo',{defaultValue:'地址2'}),
					key: "billaddress2",
					required:false,
					props:{
						readonly:true
					}
                },
                // 4
                {
					label: this.$t('erp.b2c.city',{defaultValue:'城市'}),
					key: "city",
					required:false,
					props:{
						readonly:true
					}
                },
                {
					label: this.$t('erp.b2c.city',{defaultValue:'城市'}),
					key: "billcity",
					required:false,
					props:{
						readonly:true
					}
                },
                // 5
                {
					label: this.$t('erp.b2c.state_province',{defaultValue:'州/省份'}),
					key: "state",
					required:false,
					props:{
						readonly:true
					}
                },
                {
					label: this.$t('erp.b2c.state_province',{defaultValue:'州/省份'}),
					key: "billstate",
					required:false,
					props:{
						readonly:true
					}
                },
                // 6
                {
					label: this.$t('erp.product.country_code',{defaultValue:'国家编码'}),
					key: "countryCode",
					required:false,
					props:{
						readonly:true
					}
                },
                {
					label: this.$t('erp.product.country_code',{defaultValue:'国家编码'}),
					key: "billcountryCode",
					required:false,
					props:{
						readonly:true
					}
                },
                // 7
                {
					label: this.$t('erp.b2c.zip_code',{defaultValue:'邮编'}),
					key: "postalCode",
					required:false,
					props:{
						readonly:true
					}
                },
                {
					label: this.$t('erp.b2c.zip_code',{defaultValue:'邮编'}),
					key: "billpostalCode",
					required:false,
					props:{
						readonly:true
					}
                },
                // 8
                {
					label: this.$t('erp.b2c.phone',{defaultValue:'电话'}),
					key: "phone",
					required:false,
					props:{
						readonly:true
					}
                },
                {
					label: this.$t('erp.b2c.phone',{defaultValue:'电话'}),
					key: "billphone",
					required:false,
					props:{
						readonly:true
					}
                },
                // 9
                {
					label: this.$t('erp.b2border.emergency_phone',{defaultValue:'紧急联系电话'}),
					key: "emPhone",
					required:false,
					props:{
						readonly:true
					}
                },
                {
					label: this.$t('erp.b2border.emergency_phone',{defaultValue:'紧急联系电话'}),
					key: "billemPhone",
					required:false,
					props:{
						readonly:true
					}
                },
                // 10
                {
					label: this.$t('erp.b2border.fax',{defaultValue:'传真'}),
					key: "fax",
					required:false,
					props:{
						readonly:true
					}
                },
                {
					label: this.$t('erp.b2border.fax',{defaultValue:'传真'}),
					key: "billfax",
					required:false,
					props:{
						readonly:true
					}
				},
            ]
        }
	},
	methods:{
		// 切换传递出去获取销售员
		changeSales(val){
			let objitem;
			objitem = this.getAllCustomerList.filter(item => item.value == val)
			this.$emit('on-salesId',objitem[0].attach.item.salespersonId)
		},

		getCustomerlist(val){
			this.chooseCusId = val
			// 值为空
			this.item1 = this.item2 = {}
			let {contact,address1,address2,city,state,countryCode,postalCode,phone,emPhone,fax,customerId,billcontact,billaddress1,billaddress2,billcity,billstate,billcountryCode,billpostalCode,billphone,billemPhone,billfax} = '';
			this.formData = {contact,address1,address2,city,state,countryCode,postalCode,phone,emPhone,fax,customerId,billcontact,billaddress1,billaddress2,billcity,billstate,billcountryCode,billpostalCode,billphone,billemPhone,billfax}
			// console.log(this.formData)

			this.formData.customerId = val
			this.getAllAddress(val)
		},
		getAllAddress(val){
			HttpAllCustomerAddressList({
				customerId:val,
			}).then(res=>{
				// console.log(res.data)
				this.shipaddressList = res.data.filter(item => item.type =='SHIP_TO')
				this.billaddressList = res.data.filter(item => item.type =='BILL_TO')
				if(this.alltype != 'add' && this.clickflag == 1){
					// 根据id请求对应地址
					this.detailAddress(this.olddata.shipTo,'ship',true)
					this.detailAddress(this.olddata.billTo,'bill',true)
					this.clickflag = 2
				}else{
					let shipactiveId = this.shipaddressList.filter(item=>{
						return item.isDefault == 'Y'
					})
					let billactiveId = this.billaddressList.filter(item=>{
						return item.isDefault == 'Y'
					})
					if(shipactiveId.length>0){
						this.detailAddress(shipactiveId[0].id,'ship',false)
					}
					if(billactiveId.length>0){
						this.detailAddress(billactiveId[0].id,'bill',false)
					}
				}
			},err=>{
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			})
		},
		detailAddress(conid,itemtype,onece){
			if(itemtype == 'ship'){
				let shiparritem;
				this.shipaddressList.map(item=>{
					if(item.id == conid){
						shiparritem = item;
					}
				})
				let {contact,address1,address2,city,state,countryCode,postalCode,phone,emPhone,fax,id} = shiparritem
				this.item1 = {contact,address1,address2,city,state,countryCode,postalCode,phone,emPhone,fax,id}
			}else if(itemtype == 'bill'){
				let billarritem;
				this.billaddressList.map(item=>{
					if(item.id == conid){
						billarritem = item;
					}
				})
				// console.log(arritem,'bill')
				let data = {
					billid:billarritem.id,
					billcontact:billarritem.contact,
					billaddress1:billarritem.address1,
					billaddress2:billarritem.address2,
					billcity:billarritem.city,
					billstate:billarritem.state,
					billcountryCode:billarritem.countryCode,
					billpostalCode:billarritem.postalCode,
					billphone:billarritem.phone,
					billemPhone:billarritem.emPhone,
					billfax:billarritem.fax,
				}
				this.item2 = data
			}
			this.formData = Object.assign({},this.item1,this.item2);
			
			// console.log(this.formData,'999')

			if(onece){
				this.formData.customerId = this.olddata.customerId
				this.formData.shipTo = this.olddata.shipTo
				this.formData.billTo = this.olddata.billTo
			}else{
				this.formData.customerId = this.chooseCusId
				this.formData.shipTo = this.item1.id
				this.formData.billTo = this.item2.billid
			}
		},
		async validate(){
			const bool1 = await this.$refs['editform'].validate();
			if (!bool1) {
				this.$VMessage.warning(this.$t('global.common.fill_required',{defaultValue:'请填写必填项'}));
			}
			return bool1;
		},
	}
}
</script>